import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";

import Layout from "../components/common/Layout";
import HelpUI from "../components/help/HelpUI";
// import SearchBar from "../components/common/SearchBar";
import useScreenSize from "../components/customHooks/useScreenSize";
import { Helmet } from "react-helmet";

const HelpDocs = () => {
  const screenSize = useScreenSize();
  return (
    <Layout isHomePage={false}>
      <Helmet>
        <title>Help & Support | TeammateMe</title>
        <meta
          name="description"
          content="Need help? Find answers to your questions, troubleshoot issues, and get support for TeammateMe products and services."
        />
      </Helmet>
      <section
        className={
          "container--helppage " +
          (screenSize === "largeScreen"
            ? "banner-fullHeight"
            : "banner-shortHeight")
        }
      >
        <div
          className={
            "container--helppage_wrapper" +
            (screenSize == "largeScreen" ? "" : " helppagebanner-shortHeight")
          }
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ height: "100%" }}
          >
            <Grid item>
              <Typography
                variant="h1"
                align="center"
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 700, // Bold for the first line
                  fontSize: "48px", // Larger size for the first line
                  lineHeight: "1.2",
                }}
              >
                How Can We Help?
              </Typography>
              <Typography
                variant="h1"
                align="center"
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 500, // Lighter for the second line
                  fontSize: "33px", // Smaller size for the second line
                  lineHeight: "1.2",
                  color: "#2eb790", // Adding color for emphasis
                  marginTop: "1rem",
                }}
              >
                Find Answers and Get Support from Our Team
              </Typography>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="help--layout-container">
        <HelpUI />
      </section>
    </Layout>
  );
};

HelpDocs.propTypes = {
  serverUserData: PropTypes.object,
};

export default HelpDocs;
